<template>
  <div v-if="type === 'continueBtn'" class="btn continueBtn" @click="clickContinue()">Continue</div>
  <div v-else-if="type === 'nextBtn'" :class="'nextBlock' + (canNotClick? ' canNotClick': '')" @click="clickHandler()">next</div>
  <button v-else-if="btn.link" @click="clickHandler()" :class="`btn ${type}` + checkedClassName + iconBtnClassName">
    <img v-if="btn.icon" :src="btnIcon">
    <img v-if="type === 'labelBtn'" class="labelIcon" :src="labelIconSrc">
    <span>{{ btn.text }}</span>
  </button>
  <button v-else :class="`btn ${type}` + checkedClassName + iconBtnClassName">
    <img v-if="btn.icon" :src="btnIcon">
    <img v-if="type === 'labelBtn'" class="labelIcon" :src="labelIconSrc">
    <span>{{ btn.text }}</span>
  </button>
</template>

<script>
export default {
  name: "Btn",
  props: {
    type: String,
    btn: Object,
    qsNumber: Number,
    canNotClick: Boolean
  },
  methods: {
    clickHandler(){
      if(this.canNotClick){return}

      if(this.$route.path === '/questionnaire'){
        // 点击begin按钮
        // 初始化数据
        this.$store.commit({
          type: 'initData',
        })
        // 开始问卷埋点
        this.$sensors.track('BeginQuestionnaire',{type: 'Begin'})
        
      }

      this.$emit('navigate', this.btn.text)

      setTimeout(() => {
        this.$router.push(this.btn.link)
      }, 200);
    },
    clickContinue(){
      // 点击continue按钮
      if(this.$store.state.answerQsNumber){
        // 继续问卷埋点
        this.$sensors.track('BeginQuestionnaire',{type: 'Continue'})

        this.$router.push({name: 'question' + this.$store.state.answerQsNumber})
      }
    }
  },
  computed:{
    btnIcon () {
      return this.checked ? this.btn.clickedIcon : this.btn.icon
    },
    checked(){
      return this.$store.state.qsData[this.qsNumber] && this.$store.state.qsData[this.qsNumber].answer.indexOf(this.btn.text) !== -1
    },
    checkedClassName(){
      return this.checked? ' clicked': ''
    },
    labelIconSrc(){
      return this.checked? require('@/assets/icon/checkIcon.png'): require('@/assets/icon/labelIcon.png')
    },
    iconBtnClassName(){
      return this.btn.icon? ' withIcon': ''
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@mainColor: var(--main_color);
.btn{
  background-color: #fff;
  border: 0;
  width: 505px;
  height: 80px;
  border-radius: 40px;
  text-align: center;
  line-height: 80px;
  padding: 0;
  cursor: pointer;
  span{
    font-family: var(--font_family_semibold);
    color: #000;
  }
}
@media only screen and (min-width: 768px){
  .btn:hover{
    outline: 0;
    outline: 2px solid var(--main_color);
  }
  .btn {
    span{
      font-family: var(--font_family_semibold);
      font-size: 23px;
      color: #000;
    }
  }
}
.clicked{
  background-color: @mainColor;
  span{
    color: #fff;
  }
}
.pointer{
  cursor: pointer;
}

@media only screen and (min-width: 768px){
  .shortBtn ,.secondBtn{
    margin-top: 80px; 
  }
  .nextBlock{
    position: absolute;
    right: 100px;
    bottom: 100px;
    color: var(--main_color);
    font-size: 30px;
    line-height: 36px;
    font-weight: bold;
    text-transform: capitalize;
    border-bottom: 2px solid var(--main_color);
    cursor: pointer;
  }
}
.sectionBtn{
  background-color: @mainColor;
  span{
    color: #fff;
  }
}
.continueBtn{
  width: 200px;
  height: 55px;
  border-radius: 27.5px;
  line-height: 55px;
  background-color: @mainColor;
  color: #fff;
  font-family: var(--font_family_semibold);
  font-size: 20px;
}
.shortBtn{
  width: 200px;
  height: 55px;
  border-radius: 27.5px;
  line-height: 55px;
}
.normalBtn{
  width: 310px;
  height: 70px;
  border-radius: 35px;
  line-height: 70px;
}
.longBtn{
  width: 505px;
  height: 80px;
  border-radius: 40px;
  line-height: 80px;
}
.cardBtn{
  width: 360px;
  height: 120px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  img{
    width: 80px;
    height: 80px;
    margin-right: 40px;
  }
  span{
    width: 180px;
    font-size: 22px;
    line-height: 32px;
    text-align: left;
  }
}
.labelBtn{
  position: relative;
  width: 310px;
  height: 70px;
  border-radius: 35px;
  line-height: 20px;
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  justify-content: center;
  .labelIcon{
    position: absolute;
    left: 30px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 20px;
  }
}

@media only screen and (max-width: 767px){
  img{
    width: 18px;
    height: 18px;
    margin-left: 32px;
    margin-right: 14px;
  }
  .nextBlock{
    position: static;
    right: 0;
    left: 0;
    bottom: 64px;
    margin: 30px auto;
    width: 40px;
    text-align: center;
    color: var(--main_color);
    font-size: 18px;
    line-height: 22px;
    font-weight: bold;
    text-transform: capitalize;
    border-bottom: 1px solid var(--main_color);
    cursor: pointer;
  }
  .shortBtn {
    width: 140px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-content: center;
    span {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  .continueBtn{
    width: 140px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-content: center;
    font-size: 14px;
    line-height: 40px;
  }
  .normalBtn{
    width: 205px;
    height: 50px;
    border-radius: 25px;
    line-height: 50px;
    span{
      font-size: 16px;
    }
  }
  .longBtn{
    width: 240px;
    height: 40px;
    border-radius: 25px;
    line-height: 40px;
    // padding-left: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 18px;
      height: 18px;
      margin-left: 32px;
      margin-right: 14px;
    }
    span{
      // width: 100%;
      // height: 100%;
      font-size: 12px;
      line-height: 14px;
      // text-align: left;
    }
  }
  .longBtn.withIcon{
    justify-content: flex-start;
  }
  .labelBtn{
    width: 240px;
    height: 40px;
    .labelIcon{
      position: absolute;
      left: 20px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      width: 14px;
      height: 14px;
    }
  }
  .cardBtn{
    width: 300px;
    height: 100px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    img{
      width: 50px;
      height: 50px;
      margin-right: 24px;
      margin-left: 20px;
    }
    span{
      width: 170px;
      font-size: 16px;
      line-height: 22px;
      text-align: left;
    }
  }
}
.canNotClick{
  opacity: .5;
  cursor: default;
}
</style>
